// store/adminConfig.saga.js
import { takeLatest, call, put, all, fork } from 'redux-saga/effects';
import * as ADMIN_CONFIG_ACTION_TYPES from './actionTypes';
import {
  fetchConfigDataSuccess,
  fetchConfigDataFailure,
  // College Course Mappings
  createCollegeCourseMappingSuccess,
  createCollegeCourseMappingFailure,
  updateCollegeCourseMappingSuccess,
  updateCollegeCourseMappingFailure,
  deleteCollegeCourseMappingSuccess,
  deleteCollegeCourseMappingFailure,
  // SME Course Mappings  
  createSMECourseMappingSuccess,
  createSMECourseMappingFailure,
  deleteSMECourseMappingSuccess,
  deleteSMECourseMappingFailure,
  // Degree Configurations
  createDegreeConfigurationSuccess,
  createDegreeConfigurationFailure,
  updateDegreeConfigurationSuccess,
  updateDegreeConfigurationFailure,
  deleteDegreeConfigurationSuccess,
  deleteDegreeConfigurationFailure,
  createCollegeCourseMappingStart,
  fetchCollegeDegreeMappingsStart,
  createCollegeDegreeMappingSuccess,
  createCollegeDegreeMappingFailure,
  // Fetch Degrees by College
  
  fetchCollegeDegreesSuccess,
  fetchCollegeDegreesFailure,
  // Semester Promotion
  promoteSemesterSuccess,
  promoteSemesterFailure,
  previewSemesterSuccess,
  previewSemesterFailure,
  // Fetch with filters
} from './actions';
import AdminConfigHelper from    '../../../../utils/API/BackendHelper/admin/adminConfig';  

// ================================FETCH INITIAL DATA ================================ //

function* fetchConfigDataSaga() {
  try {
    // Fetch all required data in parallel
    const [
     colleges,
      smes,
      courses,
      degrees,
    ] = yield all([
    call(AdminConfigHelper.getAllColleges),
      call(AdminConfigHelper.getAllSmes),
      call(AdminConfigHelper.getAllCourses),
      call(AdminConfigHelper.getAllDegrees),
    ]);

    // Structure data for the frontend
    const configData = {
      colleges: colleges.data || [],
      smes: smes.data || [],
      courses: courses.data || [],
      degrees: degrees.data || [],
      // mappings: {
      //   collegeCourses: collegeCourseMappings.data || [],
      //   smeCourses: smeCourseMappings.data || [],
      //   degreeCourses: degreeConfigurations.data || [],
      //   courseCategories: courseCategories.data || []
      // },
      // pagination: {
      //   collegeCourses: collegeCourseMappings.pagination,
      //   smeCourses: smeCourseMappings.pagination,
      //   degreeConfigurations: degreeConfigurations.pagination,
      //   courseCategories: courseCategories.pagination
      // }
    };

    yield put(fetchConfigDataSuccess(configData));
  } catch (error) {
    console.error('Error fetching config data:', error);
    yield put(fetchConfigDataFailure(error.message || 'Failed to fetch configuration data'));
  }
}

// ================================COLLEGE COURSE MAPPINGS ================================ //

function* createCollegeCourseMappingSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.createCollegeCourseMapping, action.payload);
    yield put(createCollegeCourseMappingSuccess(response.data));
    
    // Optionally refresh the list
    yield call(refreshCollegeCourseMappings);
  } catch (error) {
    yield put(createCollegeCourseMappingFailure(error.response?.data?.message || error.message));
  }
}

function* updateCollegeCourseMappingSaga(action) {
  try {
     console.log('Updating College Course Mapping with data:', action.payload);
    const transformedData ={
      academic_year: action.payload.data.academicYear,
      college_id: action.payload.data.collegeId,
      course_id: action.payload.data.courseId,
      max_enrollments: action.payload.data.maxEnrollments,
      degree: action.payload.data.degree,
      is_mandatory: action.payload.data.isMandatory,
      semester: action.payload.data.semester,
      is_active: action.payload.data.isActive

    }

    const { mappingId, data } = action.payload;
    const response = yield call(AdminConfigHelper.updateCollegeCourseMapping, mappingId, transformedData);
    yield put(updateCollegeCourseMappingSuccess(response.data));
  } catch (error) {
    yield put(updateCollegeCourseMappingFailure(error.response?.data?.message || error.message));
  }
}

function* deleteCollegeCourseMappingSaga(action) {
  try {
    yield call(AdminConfigHelper.deleteCollegeCourseMapping, action.payload);
    yield put(deleteCollegeCourseMappingSuccess(action.payload));
  } catch (error) {
    yield put(deleteCollegeCourseMappingFailure(error.response?.data?.message || error.message));
  }
}

function* refreshCollegeCourseMappings() {
  try {
    const response = yield call(AdminConfigHelper.getCollegeCourseMappings, { limit: 100 });
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.REFRESH_COLLEGE_COURSE_MAPPINGS,
      payload: response.data
    });
  } catch (error) {
    console.error('Error refreshing college course mappings:', error);
  }
}

// ================================SME COURSE MAPPINGS ================================ //

function* createSMECourseMappingSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.createSMECourseMapping, action.payload);
    yield put(createSMECourseMappingSuccess(response.data));
    
    // Optionally refresh the list
    yield call(refreshSMECourseMappings);
  } catch (error) {
    yield put(createSMECourseMappingFailure(error.response?.data?.message || error.message));
  }
}

function* deleteSMECourseMappingSaga(action) {
  try {
    yield call(AdminConfigHelper.deleteSMECourseMapping, action.payload);
    yield put(deleteSMECourseMappingSuccess(action.payload));
  } catch (error) {
    yield put(deleteSMECourseMappingFailure(error.response?.data?.message || error.message));
  }
}

function* refreshSMECourseMappings() {
  try {
    const response = yield call(AdminConfigHelper.getSMECourseMappings, { limit: 100 });
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.REFRESH_SME_COURSE_MAPPINGS,
      payload: response.data
    });
  } catch (error) {
    console.error('Error refreshing SME course mappings:', error);
  }
}

// ================================DEGREE CONFIGURATIONS ================================ //

function* createDegreeConfigurationSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.createDegreeConfiguration, action.payload);
    yield put(createDegreeConfigurationSuccess(response.data));
    
    yield call(refreshDegreeConfigurations);
  } catch (error) {
    yield put(createDegreeConfigurationFailure(error.response?.data?.message || error.message));
  }
}

function* updateDegreeConfigurationSaga(action) {
  try {
    const { degreeId, data } = action.payload;
    const response = yield call(AdminConfigHelper.updateDegreeConfiguration, degreeId, data);
    yield put(updateDegreeConfigurationSuccess(response.data));
  } catch (error) {
    yield put(updateDegreeConfigurationFailure(error.response?.data?.message || error.message));
  }
}

function* deleteDegreeConfigurationSaga(action) {
  try {
    yield call(AdminConfigHelper.deleteDegreeConfiguration, action.payload);
    yield put(deleteDegreeConfigurationSuccess(action.payload));
  } catch (error) {
    yield put(deleteDegreeConfigurationFailure(error.response?.data?.message || error.message));
  }
}

function* refreshDegreeConfigurations() {
  try {
    const response = yield call(AdminConfigHelper.getDegreeConfigurations, { limit: 100 });
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.REFRESH_DEGREE_CONFIGURATIONS,
      payload: response.data
    });
  } catch (error) {
    console.error('Error refreshing degree configurations:', error);
  }
}

// ================================PAGINATION AND FILTERING ================================ //

function* fetchCollegeCourseMappingsWithFiltersSaga(action) {
  try {
    console.log('Fetching College Course Mappings with filters:', action.payload);
    const response = yield call(AdminConfigHelper.getCollegeCourseMappings, action.payload);
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.FETCH_COLLEGE_COURSE_MAPPINGS_SUCCESS,
      payload: {
        data: response.data,
        pagination: response.pagination,
        filters: action.payload
      }
    });
  } catch (error) {
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.FETCH_COLLEGE_COURSE_MAPPINGS_FAILURE,
      payload: error.message
    });
  }
}


// ================================FETCH DEGREE BY COLLEGE ================================ //
function* fetchCollegeDegreesSaga(action) {
  try {
    const { collegeId } = action.payload;
    
    // API call to get degrees for specific college
    const response = yield call(AdminConfigHelper.getDegreesByCollege, collegeId);
    console.log('Fetched Degrees for College response:', response);
    
    if (response.success) {
      
      yield put(fetchCollegeDegreesSuccess(response.data));
    } else {
      yield put(fetchCollegeDegreesFailure(response.data.message || 'Failed to fetch college degrees'));
    }
  } catch (error) {
    console.error('Fetch college degrees error:', error);
    yield put(fetchCollegeDegreesFailure(
      error.response?.data?.message || error.message || 'An error occurred while fetching college degrees'
    ));
  }
}


function* fetchSMECourseMappingsWithFiltersSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.getSMECourseMappings, action.payload);
    console.log('Fetched SME Course Mappings:', response);
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.FETCH_SME_COURSE_MAPPINGS_SUCCESS,
      payload: {
        data: response.data,
        pagination: response.pagination,
        filters: action.payload
      }
    });
  } catch (error) {
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.FETCH_SME_COURSE_MAPPINGS_FAILURE,
      payload: error.message
    });
  }
}

function* fetchDegreeConfigurationsWithFiltersSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.getDegreeConfigurations, action.payload);
    console.log('Fetched Degree Configurations:', response);
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.FETCH_DEGREE_CONFIGURATIONS_SUCCESS,
      payload: {
        data: response.data,
        pagination: response.pagination,
        filters: action.payload
      }
    });
  } catch (error) {
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.FETCH_DEGREE_CONFIGURATIONS_FAILURE,
      payload: error.message
    });
  }
}



function* refreshCollegeDegreeMappings() {
  try {
    const response = yield call(AdminConfigHelper.getCollegeDegreeMappings, { limit: 100 });
    // yield put({
    //   type: ADMIN_CONFIG_ACTION_TYPES.REFRESH_COLLEGE_DEGREE_MAPPINGS,
    //   payload: response.data
    // });
  } catch (error) {
    console.error('Error refreshing college degree mappings:', error);
  }
}

function* createCollegeDegreeMappingSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.createCollegeDegreeMapping, action.payload);
    yield put(createCollegeDegreeMappingSuccess(response.data));

    yield call(refreshCollegeDegreeMappings);
  } catch (error) {
    yield put(createCollegeDegreeMappingFailure(error.response?.data?.message || error.message));
  }
}



function* fetchCollegeDegreeMappingsWithFiltersSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.getCollegeDegreeMappings, action.payload);
    console.log('Fetched College Degree Mappings:', response);
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.FETCH_COLLEGE_DEGREE_MAPPINGS_SUCCESS,
      payload: {
        data: response.data,
        pagination: response.pagination,
        filters: action.payload
      }
    });
  } catch (error) {
    yield put({
      type: ADMIN_CONFIG_ACTION_TYPES.FETCH_COLLEGE_DEGREE_MAPPINGS_FAILURE,
      payload: error.message
    });
  }
}

// ================================SEMESTER PROMOTION ================================ //

function* promoteSemesterSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.promoteSemester, action.payload);
    yield put(promoteSemesterSuccess(response.data));
  } catch (error) {
    yield put(promoteSemesterFailure(error.response?.data?.message || error.message));
  }
}

function* previewSemesterSaga(action) {
  try {
    const response = yield call(AdminConfigHelper.previewSemesterPromotion, action.payload);
    yield put(previewSemesterSuccess(response.data));
  } catch (error) {
    yield put(previewSemesterFailure(error.response?.data?.message || error.message));
  }
}


// ================================ROOT SAGA ================================ //

function* watchFetchConfigData() {
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.FETCH_CONFIG_DATA_START, fetchConfigDataSaga);
}

function* watchCollegeCourseMappings() {
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.CREATE_COLLEGE_COURSE_MAPPING_START, createCollegeCourseMappingSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.UPDATE_COLLEGE_COURSE_MAPPING_START, updateCollegeCourseMappingSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.DELETE_COLLEGE_COURSE_MAPPING_START, deleteCollegeCourseMappingSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.FETCH_COLLEGE_DEGREES_START, fetchCollegeDegreesSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.FETCH_COLLEGE_COURSE_MAPPINGS_WITH_FILTERS, fetchCollegeCourseMappingsWithFiltersSaga);
}

function* watchSMECourseMappings() {
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.CREATE_SME_COURSE_MAPPING_START, createSMECourseMappingSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.DELETE_SME_COURSE_MAPPING_START, deleteSMECourseMappingSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.FETCH_SME_COURSE_MAPPINGS_WITH_FILTERS, fetchSMECourseMappingsWithFiltersSaga);
}

function* watchDegreeConfigurations() {
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.CREATE_DEGREE_CONFIGURATION_START, createDegreeConfigurationSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.UPDATE_DEGREE_CONFIGURATION_START, updateDegreeConfigurationSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.DELETE_DEGREE_CONFIGURATION_START, deleteDegreeConfigurationSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.FETCH_DEGREE_CONFIGURATIONS_WITH_FILTERS, fetchDegreeConfigurationsWithFiltersSaga);
}


function* watchCollegeDegreeMappings() {
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.CREATE_COLLEGE_DEGREE_MAPPING_START, createCollegeDegreeMappingSaga);
  // yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.UPDATE_COLLEGE_DEGREE_MAPPING_START, updateCollegeDegreeMappingSaga);
  // yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.DELETE_COLLEGE_DEGREE_MAPPING_START, deleteCollegeDegreeMappingSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.FETCH_COLLEGE_DEGREE_MAPPINGS_START, fetchCollegeDegreeMappingsWithFiltersSaga);
}

function* watchSemesterPromotion() {
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.PREVIEW_SEMESTER_START, previewSemesterSaga);
  yield takeLatest(ADMIN_CONFIG_ACTION_TYPES.PROMOTE_SEMESTER_START, promoteSemesterSaga);
}

function* adminConfigSaga() {
  yield all([
     fork(watchFetchConfigData),
    fork(watchCollegeCourseMappings),
    fork(watchSMECourseMappings),
    fork(watchDegreeConfigurations),
    fork(watchCollegeDegreeMappings),
    fork(watchSemesterPromotion)
  ]);
}

export default adminConfigSaga;
